import { get, post } from "@/utils/request";
// 待审批
export const getPendingApprovalList = (params: any) =>
  post("/api/approvalManagement/getCurrentMyPageList", params);
// 已审批
export const getApprovalList = (params: any) =>
  post("/api/approvalManagement/getApprovaledMyPageList", params);
// 抄送我的
export const getCopylList = (params: any) =>
  post("/api/approvalManagement/getCCToMyPageList", params);
// 申请列表
export const getApplylList = (params: any) =>
  post("/api/companyBusiness/pagelist", params);
// 我发起的
export const getMyCreatedList = (params: any) =>
  post("/api/approvalManagement/getCreatedMyPageList", params);
  // 设置抄送状态
export const setReadStatus = (params: any) =>
  post("/api/approvalManagement/setReadStatus", params);
  
